import React, {useRef, useState} from 'react';
import styles from '../pages/PwChangeForce.module.css';
import {E3Button, E3Input} from "e3-components/components";
import {useHookForm} from "e3-common/hooks/useHookForm";
import {validate} from "e3-common/utils/validationUtil";
import {setSessionStorageItem} from "e3-common/utils/localStorageUtil";
import {LOCAL_STORAGE_KEYS} from "e3-common/constants/enumerates";
import {clear} from "e3-common/utils/controlsUtil";
import {useBoundStore} from "e3-common/store/useBoundStore";
import useMessageBox from "e3-common/hooks/useMessageBox";
import useAuth from "e3-common/hooks/useAuth";
import useFetch from "e3-common/hooks/useFetch";
import {useToast} from "e3-common/hooks/useToast";
const PwChangeForce = () => {
    const userId = useBoundStore((state) => state.user.userId);
    const { alert, confirm } = useMessageBox();
    const { logout } = useAuth();
    const { request } = useFetch();
    const {Success} = useToast()

    const controls = {
        form : {
            txtOriginPassword: {
                ref: useRef(),
                label: '비밀번호',
                validation: {
                    required: true,
                    type: null,
                    minMaxRange: { min: null, max: null },
                    lengthRange: { min: null, max: null },
                },
                controlOption: {
                    placeholder: '초기 비밀번호를 입력하세요.'
                }
            },
            txtNewPassword: {
                ref: useRef(),
                label: '비밀번호',
                validation: {
                    required: true,
                    type: null,
                    minMaxRange: { min: null, max: null },
                    lengthRange: { min: null, max: null },
                },
                controlOption: {
                    placeholder: '신규 비밀번호를 입력하세요.'
                }
            },
            txtChkPassword: {
                ref: useRef(),
                label: '비밀번호',
                onEnterPress: (e) => {
                    pageFunctions.pwChange(e);
                },
                validation: {
                    required: true,
                    type: null,
                    minMaxRange: { min: null, max: null },
                    lengthRange: { min: null, max: null },
                },
                controlOption: {
                    placeholder: '신규 비밀번호를 다시 입력하세요.'
                }
            },
        },
        buttons: {
            btnConfirm: {
                label: '비밀번호 변경',
                checkAuth: true,
                onClick: (e) => {
                    pageFunctions.pwChange(e);
                },
                styles : {width: '200px'},
            },
        },
    }

    const {getValues: getFormValues} = useHookForm(controls.form);
    const pageFunctions = {
        validatePW: async () => {
            const newPW = controls.form.txtNewPassword.ref;
            const chkPW = controls.form.txtChkPassword.ref;

            if (validate(controls.form)) {
                if (newPW.current?.getValue() !== chkPW.current?.getValue()) {
                    alert('', '비밀번호 확인이 일치하지 않습니다.');
                    throw new Error('비밀번호 확인이 일치하지 않습니다.');
                }
            }
        },
        validChk: async () => {
            const chkPW = controls.form.txtChkPassword.ref.current?.getValue();

            if (chkPW.length < 10) {
                alert('', '비밀번호는 10자 이상입니다.');
                throw new Error('비밀번호는 10자 이상입니다.');
            } else if (chkPW.length > 30) {
                alert('', '비밀번호는 30자 이하입니다.');
                throw new Error('비밀번호는 30자 이하입니다.');
            }

            if ((chkPW.match(/[\p{Script=Hangul}]/u) || []).length) {
                alert('', '비밀번호에 한글은 사용할 수 없습니다.');
                throw new Error('비밀번호에 한글은 사용할 수 없습니다.');
            } else {
                const chkItem = {
                    digit: (chkPW.match(/\d/g) || []).length,
                    lower: (chkPW.match(/[a-z]/g) || []).length,
                    upper: (chkPW.match(/[A-Z]/g) || []).length,
                    special: (
                        chkPW.match(
                            /[\!\@\#\$\%\^\&\*\(\)\-\_\=\~\:\;\<\>\.\,\{\}\[\]\\\|\'\`\?]/g
                        ) || []
                    ).length,
                };

                let cnt = 0;
                for (let i in chkItem) {
                    if (chkItem[i] > 0) cnt++;
                }

                if (cnt < 3) {
                    alert(
                        '',
                        '비밀번호는 대문자, 소문자, 특수문자, 숫자 중 3가지 이상 조합해야 합니다.'
                    );
                    throw new Error(
                        '비밀번호는 대문자, 소문자, 특수문자, 숫자 중 3가지 이상 조합해야 합니다.'
                    );
                }
            }
        },
        commonValidChk: async () => {
            const chkPW = controls.form.txtChkPassword.ref.current?.getValue();
            const regex = /^[0-9]+$/;

            if (chkPW.length < 6) {
                alert('', '비밀번호는 6자 이상입니다.');
                throw new Error('비밀번호는 6자 이상입니다.');
            }

            if (!regex.test(chkPW)) {
                alert('', '비밀번호는 숫자만 가능합니다.');
                throw new Error('비밀번호는 숫자만 가능합니다.');
            }
        },
        pwChange: async (e) => {
            e.preventDefault();
            const confirmResult = await confirm('confirm', '비밀번호를 변경하시겠습니까?');

            if (confirmResult) {
                try {
                    await pageFunctions.validatePW();
                    await pageFunctions.validChk();

                    const requestOptions = {
                        method: 'POST',
                        body: {
                            USER_ID: userId,
                            PASSWORD: controls.form.txtOriginPassword.ref.current?.getValue(),
                            NEW_PASSWORD: controls.form.txtNewPassword.ref.current?.getValue(),
                        },
                    };
                    const messageOptions = {
                        showAlert: true,
                        alertTitle: '오류',
                        showSuccess: false,
                        showConfirm: false,
                        showLoad: false,
                    };
                    const response = await request(
                        // '/user/password-change',
                        '/E3/SYSTEM/ChangePassword',
                        requestOptions,
                        messageOptions
                    );
                    if (response) {
                        setSessionStorageItem(
                            LOCAL_STORAGE_KEYS.ACCESS_TOKEN,
                            response.USER.ACCESS_TOKEN
                        );
                        await pageFunctions.initForm();
                    }
                } catch (e) {
                    alert('', e.message);
                }
            }
        },
        initForm: async () => {
            Success("다시 로그인해주세요")
            await clear(controls.form, true);
            await logout(userId);
        },
    }

    return (
        <div className={styles.pwChange_pageContainer}>
            <div className={styles.pwChange_wrapper }>
                        <h1 className={styles.title}>🔒비밀번호 재설정</h1>
                        <div className={styles.group}>
                            <div className={styles.inputGroup}>
                                <label>초기 비밀번호</label>
                                <E3Input
                                        ref={controls.form.txtOriginPassword.ref}
                                        type="password"
                                        placeholder={controls.form.txtOriginPassword.controlOption.placeholder}
                                        maxLength={50}
                                />
                            </div>
                            <div className={styles.inputGroup}>
                                <label>신규 비밀번호</label>
                                <E3Input
                                    ref={controls.form.txtNewPassword.ref}
                                    type="password"
                                    placeholder={controls.form.txtNewPassword.controlOption.placeholder}
                                    maxLength={50}
                                />
                            </div>
                            <div className={styles.inputGroup}>
                                <label>신규 비밀번호 확인</label>
                                <E3Input
                                    ref={controls.form.txtChkPassword.ref}
                                    type="password"
                                    placeholder={controls.form.txtChkPassword.controlOption.placeholder}
                                    maxLength={50}
                                    onEnterPress={controls.form.txtChkPassword.onEnterPress}
                                />
                            </div>
                        </div>
                        <div className={styles.description}>
                            <span>대문자, 소문자, 특수문자, 숫자</span>중 3가지 이상 조합하여 10자 이상을 사용하세요
                        </div>
                        <div className={styles.submit}>
                            <E3Button
                                label={controls.buttons.btnConfirm.label}
                                colorType={'main'}
                                style={{width:'100%',height : '30px',borderRadius: '12px'}}
                                authBtn={'LOGIN'}
                                checkAuth={true}
                                onClick={controls.buttons.btnConfirm.onClick}
                            />
                        </div>
            </div>
        </div>
    );
};

export default PwChangeForce;
